// extracted by mini-css-extract-plugin
export default {"bottomCtas":"VerifyOtp_bottomCtas__sWR++","waitAndAction":"VerifyOtp_waitAndAction__RHy8O"};